import { MoneyPrintMixin } from "@/components/money/mixins/print.mixin";
import { Component, Mixins } from "vue-property-decorator";
import Template from "./VoidTillSlip.template.vue";

@Component({
  mixins: [Template]
})
export class VoidTillSlipComponent extends Mixins(MoneyPrintMixin) {
  protected created() {
    this.$emit("readyToPrint");
  }
}
